(() => {
  const initLogoCarousel = (root) => {
    const viewport = root.querySelector("[data-logo-carousel-viewport]");
    const list = root.querySelector("[data-logo-carousel-list]");
    const clone = root.querySelector("[data-logo-carousel-clone]");
    if (!viewport || !list || !clone) return;

    const update = () => {
      const viewportWidth = viewport.clientWidth;
      const listWidth = list.scrollWidth;
      if (!viewportWidth || !listWidth) return;

      const alwaysScroll = root.dataset.alwaysScroll === "true";
      const gap =
        parseFloat(getComputedStyle(root).getPropertyValue("--logo-carousel-gap")) ||
        0;

      // Ensure we have enough repeated content to avoid "blank space" when the list is short.
      // We aim for ~2x viewport width to cover the fade + ensure seamless loop.
      const desiredTrackWidth = viewportWidth * 2;
      const neededCopies = Math.max(2, Math.ceil(desiredTrackWidth / listWidth));

      // Keep the first clone as a template; remove any additional clones we previously inserted.
      clone.dataset.logoCarouselCloneTemplate = "true";
      const extraClones = root.querySelectorAll(
        "[data-logo-carousel-clone]:not([data-logo-carousel-clone-template])"
      );
      extraClones.forEach((n) => n.remove());

      // Create extra copies if needed.
      for (let i = 2; i < neededCopies; i++) {
        const n = clone.cloneNode(true);
        n.removeAttribute("data-logo-carousel-clone-template");
        n.setAttribute("aria-hidden", "true");
        n.querySelectorAll("a").forEach((a) => a.setAttribute("tabindex", "-1"));
        clone.parentNode.appendChild(n);
      }

      // The loop must move exactly 1 list-width (plus the inter-list gap) for a seamless repeat.
      root.style.setProperty("--logo-carousel-shift", `${listWidth + gap}px`);

      // If not always-scroll, stop animation when it doesn't overflow.
      const shouldScroll = list.scrollWidth > viewportWidth + 4;
      root.classList.toggle("logo-carousel--static", !alwaysScroll && !shouldScroll);
    };

    update();
    requestAnimationFrame(update);

    // Re-check when images load (lazy-loaded logos change widths).
    root.querySelectorAll("img").forEach((img) => {
      if (!img.complete) img.addEventListener("load", update, { once: true });
    });

    if (window.ResizeObserver) {
      const ro = new ResizeObserver(update);
      ro.observe(viewport);
      ro.observe(list);
    } else {
      window.addEventListener("resize", update, { passive: true });
    }
  };

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll("[data-logo-carousel]")
      .forEach((root) => initLogoCarousel(root));
  });
})();
